/**
 * Icon components using Lucide React
 */

import {
  Home,
  Building2,
  Users,
  Settings,
  LogOut,
  Plus,
  Edit,
  Trash2,
  Eye,
  EyeOff,
  Check,
  X,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  Search,
  Filter,
  RefreshCw,
  Loader,
  AlertCircle,
  CheckCircle,
  XCircle,
  Info,
  Shield,
  Key,
  Database,
  CreditCard,
  Link,
  Unlink,
  Activity,
  BarChart3,
  TrendingUp,
  TrendingDown,
  Calendar,
  Clock,
  Mail,
  Send,
  Phone,
  MapPin,
  Globe,
  DollarSign,
  Percent,
  FileText,
  Upload,
  Download,
  Copy,
  ExternalLink,
  MoreVertical,
  Menu,
  Zap,
  Rocket,
  Package,
  Store,
  Utensils,
  Truck,
  BookOpen,
  HelpCircle,
  LayoutGrid
} from 'lucide-react';

export const Icons = {
  // Navigation
  Home,
  Building: Building2,
  Users,
  Settings,
  LogOut,
  Menu,
  
  // Actions
  Plus,
  Edit,
  Trash: Trash2,
  Eye,
  EyeOff,
  Check,
  X,
  Copy,
  Upload,
  Download,
  ExternalLink,
  MoreVertical,
  
  // Navigation arrows
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  
  // Search & Filter
  Search,
  Filter,
  RefreshCw,
  Loader,
  
  // Status
  AlertCircle,
  CheckCircle,
  XCircle,
  Info,
  
  // Security
  Shield,
  Key,
  
  // Data & Integration
  Database,
  CreditCard,
  Link,
  Unlink,
  
  // Analytics
  Activity,
  BarChart: BarChart3,
  TrendingUp,
  TrendingDown,
  
  // Time
  Calendar,
  Clock,
  
  // Contact
  Mail,
  Send,
  Phone,
  MapPin,
  Globe,
  
  // Business
  DollarSign,
  Percent,
  FileText,
  Package,
  Store,
  Utensils,
  Truck,
  BookOpen,
  
  // Special
  Zap,
  Rocket,
  
  // Help
  HelpCircle,

  LayoutGrid
};

export default Icons;
